import React from "react";

const OutputDetails = ({ outputDetails }) => {
  return (
    <div className="metrics-container mt-4 flex flex-col space-y-3">
      <p className="text-sm text-dark">
        Status:{" "}
        <span className="font-semibold px-2 py-1 fw-bold rounded-md bg-gray-100">
          {outputDetails?.status?.description}
        </span>
      </p>
      <p className="text-sm text-dark">
        Memory:{" "}
        <span className="font-semibold px-2 py-1 fw-bold rounded-md bg-gray-100">
          {outputDetails?.memory}
        </span>
      </p>
      <p className="text-sm text-dark">
        Time:{" "}
        <span className="font-semibold px-2 py-1 fw-bold rounded-md bg-gray-100">
          {outputDetails?.time}
        </span>
      </p>
    </div>
  );
};

export default OutputDetails;
